<p>base-modal-with-profile-picture works!</p>
